/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2025-09-22 17:35:34
 */
import React, { useCallback } from 'react'
import { Collapse } from 'antd'
import { VerifyResult } from '../../types'

import approve_image from '../../../../images/verify-auth/approve_image.png'
import not_approve_image from '../../../../images/verify-auth/not_approve_image.png'
import fake_icon from '../../../../images/verify-auth/fake_icon.png'
import true_icon from '../../../../images/verify-auth/true_icon.png'
import warn_icon from '../../../../images/verify-auth/info_icon.png'

interface CardFrameProps {
  result: VerifyResult
  children: React.ReactNode
}

const { Panel } = Collapse

const PanelHeader = React.memo(
  ({ status, count }: { status: string; count: number }) => {
    if (status === 'success') {
      return (
        <div className="title-text">
          <img src={true_icon} alt="" className="left-icon" />
          验真通过：{count} 张真实照片，时间、日期、地点均为真实数据
        </div>
      )
    }
    if (status === 'fail') {
      return (
        <div className="title-text">
          <img src={fake_icon} alt="" className="left-icon" />
          验真不通过：{count} 张照片未通过验真，时间、日期、地点或被篡改
        </div>
      )
    }
    if (status === 'unKnow') {
      return (
        <div className="title-text">
          <img src={warn_icon} alt="" className="left-icon" />
          照片无法鉴别，请点击照片查看具体原因
        </div>
      )
    }
    return null
  }
)

const StampImage = React.memo(({ status }: { status: string }) => {
  if (status === 'success') {
    return <img src={approve_image} alt="" className="result-image" />
  }
  if (status === 'fail') {
    return <img src={not_approve_image} alt="" className="result-image" />
  }
  return null
})

export default ({ result, children }: CardFrameProps) => {
  const { list, status, taskID } = result
  const getBorder = useCallback(() => {
    if (status === 'success') {
      return '2px solid rgba(32, 183, 89, 0.5)'
    } else if (status === 'fail') {
      return '2px solid rgba(252, 49, 49, 0.5)'
    } else {
      return ''
    }
  }, [status])
  return (
    <Collapse
      defaultActiveKey={['1']}
      className="result-card-v2"
      style={{ border: getBorder() }}
      expandIconPosition="end"
    >
      <Panel
        header={<PanelHeader status={status} count={list.length} />}
        key="1"
      >
        <StampImage status={status} />
        {children}
      </Panel>
    </Collapse>
  )
}
